import { BaseReducer } from '@identic/api';
import { GradingState, GradingInitialState, GradingActions } from './grading.state';

export function GradingReducer(state: GradingState = GradingInitialState, action: any): GradingState {
  return BaseReducer(state, action, GradingActions);
}
// console.log(`%cGradingReducer::ngOnInit`, 'background:yellow');
